import { SalesIncentiveType } from "@omni/types/api/product/bff/shared/enums/salesIncentiveType.enum";
import { CloudSalesIncentiveType } from "@omni/types/api/product/cloud/shared/enums/salesIncentiveType.enum";
import { AlgoliaSearchSalesIncentiveType } from "@omni/types/api/search/algolia/product/shared/enums/salesIncentiveType.enum";
import { BffSearchSalesIncentiveType } from "@omni/types/api/search/bff/product/shared/enums/salesIncentiveType.enum";

const fromCloudToBffMap: Record<CloudSalesIncentiveType, SalesIncentiveType> = {
    [CloudSalesIncentiveType.Cashback]: SalesIncentiveType.Cashback,
    [CloudSalesIncentiveType.ActiePrijs]: SalesIncentiveType.ActiePrijs,
    [CloudSalesIncentiveType.CombinatiePrijs]:
        SalesIncentiveType.CombinatiePrijs,
    [CloudSalesIncentiveType.GratisArtikel]: SalesIncentiveType.GratisArtikel,
    [CloudSalesIncentiveType.KortingProcent]: SalesIncentiveType.KortingProcent,
    [CloudSalesIncentiveType.FolderPrijs]: SalesIncentiveType.FolderPrijs,
    [CloudSalesIncentiveType.OutletPrijs]: SalesIncentiveType.OutletPrijs,
    [CloudSalesIncentiveType.EveryDayLowPrice]:
        SalesIncentiveType.EveryDayLowPrice,
    [CloudSalesIncentiveType.GratisTransport]:
        SalesIncentiveType.GratisTransport,
    [CloudSalesIncentiveType.ExtraBonusPunten]:
        SalesIncentiveType.ExtraBonusPunten
};

const fromBffToCloudMap: Record<SalesIncentiveType, CloudSalesIncentiveType> = {
    [SalesIncentiveType.Cashback]: CloudSalesIncentiveType.Cashback,
    [SalesIncentiveType.ActiePrijs]: CloudSalesIncentiveType.ActiePrijs,
    [SalesIncentiveType.CombinatiePrijs]:
        CloudSalesIncentiveType.CombinatiePrijs,
    [SalesIncentiveType.GratisArtikel]: CloudSalesIncentiveType.GratisArtikel,
    [SalesIncentiveType.KortingProcent]: CloudSalesIncentiveType.KortingProcent,
    [SalesIncentiveType.FolderPrijs]: CloudSalesIncentiveType.FolderPrijs,
    [SalesIncentiveType.OutletPrijs]: CloudSalesIncentiveType.OutletPrijs,
    [SalesIncentiveType.EveryDayLowPrice]:
        CloudSalesIncentiveType.EveryDayLowPrice,
    [SalesIncentiveType.GratisTransport]:
        CloudSalesIncentiveType.GratisTransport,
    [SalesIncentiveType.ExtraBonusPunten]:
        CloudSalesIncentiveType.ExtraBonusPunten
};

const fromAlgoliaSearchToBffMap: Record<
    AlgoliaSearchSalesIncentiveType,
    SalesIncentiveType
> = {
    [AlgoliaSearchSalesIncentiveType.Cashback]: SalesIncentiveType.Cashback,
    [AlgoliaSearchSalesIncentiveType.ActiePrijs]: SalesIncentiveType.ActiePrijs,
    [AlgoliaSearchSalesIncentiveType.CombinatiePrijs]:
        SalesIncentiveType.CombinatiePrijs,
    [AlgoliaSearchSalesIncentiveType.GratisArtikel]:
        SalesIncentiveType.GratisArtikel,
    [AlgoliaSearchSalesIncentiveType.KortingProcent]:
        SalesIncentiveType.KortingProcent,
    [AlgoliaSearchSalesIncentiveType.FolderPrijs]:
        SalesIncentiveType.FolderPrijs,
    [AlgoliaSearchSalesIncentiveType.OutletPrijs]:
        SalesIncentiveType.OutletPrijs,
    [AlgoliaSearchSalesIncentiveType.EveryDayLowPrice]:
        SalesIncentiveType.EveryDayLowPrice,
    [AlgoliaSearchSalesIncentiveType.GratisTransport]:
        SalesIncentiveType.GratisTransport,
    [AlgoliaSearchSalesIncentiveType.ExtraBonusPunten]:
        SalesIncentiveType.ExtraBonusPunten
};

const fromAlgoliaSearchToBffSearchMap: Record<
    AlgoliaSearchSalesIncentiveType,
    BffSearchSalesIncentiveType
> = {
    [AlgoliaSearchSalesIncentiveType.Cashback]:
        BffSearchSalesIncentiveType.Cashback,
    [AlgoliaSearchSalesIncentiveType.ActiePrijs]:
        BffSearchSalesIncentiveType.ActiePrijs,
    [AlgoliaSearchSalesIncentiveType.CombinatiePrijs]:
        BffSearchSalesIncentiveType.CombinatiePrijs,
    [AlgoliaSearchSalesIncentiveType.GratisArtikel]:
        BffSearchSalesIncentiveType.GratisArtikel,
    [AlgoliaSearchSalesIncentiveType.KortingProcent]:
        BffSearchSalesIncentiveType.KortingProcent,
    [AlgoliaSearchSalesIncentiveType.FolderPrijs]:
        BffSearchSalesIncentiveType.FolderPrijs,
    [AlgoliaSearchSalesIncentiveType.OutletPrijs]:
        BffSearchSalesIncentiveType.OutletPrijs,
    [AlgoliaSearchSalesIncentiveType.EveryDayLowPrice]:
        BffSearchSalesIncentiveType.EveryDayLowPrice,
    [AlgoliaSearchSalesIncentiveType.GratisTransport]:
        BffSearchSalesIncentiveType.GratisTransport,
    [AlgoliaSearchSalesIncentiveType.ExtraBonusPunten]:
        BffSearchSalesIncentiveType.ExtraBonusPunten
};

const fromBffToAlgoliaSearchMap: Record<
    SalesIncentiveType,
    AlgoliaSearchSalesIncentiveType
> = {
    [SalesIncentiveType.Cashback]: AlgoliaSearchSalesIncentiveType.Cashback,
    [SalesIncentiveType.ActiePrijs]: AlgoliaSearchSalesIncentiveType.ActiePrijs,
    [SalesIncentiveType.CombinatiePrijs]:
        AlgoliaSearchSalesIncentiveType.CombinatiePrijs,
    [SalesIncentiveType.GratisArtikel]:
        AlgoliaSearchSalesIncentiveType.GratisArtikel,
    [SalesIncentiveType.KortingProcent]:
        AlgoliaSearchSalesIncentiveType.KortingProcent,
    [SalesIncentiveType.FolderPrijs]:
        AlgoliaSearchSalesIncentiveType.FolderPrijs,
    [SalesIncentiveType.OutletPrijs]:
        AlgoliaSearchSalesIncentiveType.OutletPrijs,
    [SalesIncentiveType.EveryDayLowPrice]:
        AlgoliaSearchSalesIncentiveType.EveryDayLowPrice,
    [SalesIncentiveType.GratisTransport]:
        AlgoliaSearchSalesIncentiveType.GratisTransport,
    [SalesIncentiveType.ExtraBonusPunten]:
        AlgoliaSearchSalesIncentiveType.ExtraBonusPunten
};

const fromCloudToAlgoliaSearchMap: Record<
    CloudSalesIncentiveType,
    AlgoliaSearchSalesIncentiveType
> = {
    [CloudSalesIncentiveType.Cashback]:
        AlgoliaSearchSalesIncentiveType.Cashback,
    [CloudSalesIncentiveType.ActiePrijs]:
        AlgoliaSearchSalesIncentiveType.ActiePrijs,
    [CloudSalesIncentiveType.CombinatiePrijs]:
        AlgoliaSearchSalesIncentiveType.CombinatiePrijs,
    [CloudSalesIncentiveType.GratisArtikel]:
        AlgoliaSearchSalesIncentiveType.GratisArtikel,
    [CloudSalesIncentiveType.KortingProcent]:
        AlgoliaSearchSalesIncentiveType.KortingProcent,
    [CloudSalesIncentiveType.FolderPrijs]:
        AlgoliaSearchSalesIncentiveType.FolderPrijs,
    [CloudSalesIncentiveType.OutletPrijs]:
        AlgoliaSearchSalesIncentiveType.OutletPrijs,
    [CloudSalesIncentiveType.EveryDayLowPrice]:
        AlgoliaSearchSalesIncentiveType.EveryDayLowPrice,
    [CloudSalesIncentiveType.GratisTransport]:
        AlgoliaSearchSalesIncentiveType.GratisTransport,
    [CloudSalesIncentiveType.ExtraBonusPunten]:
        AlgoliaSearchSalesIncentiveType.ExtraBonusPunten
};

const fromBffSearchToBffMap: Record<
    BffSearchSalesIncentiveType,
    SalesIncentiveType
> = {
    [BffSearchSalesIncentiveType.Cashback]: SalesIncentiveType.Cashback,
    [BffSearchSalesIncentiveType.ActiePrijs]: SalesIncentiveType.ActiePrijs,
    [BffSearchSalesIncentiveType.CombinatiePrijs]:
        SalesIncentiveType.CombinatiePrijs,
    [BffSearchSalesIncentiveType.GratisArtikel]:
        SalesIncentiveType.GratisArtikel,
    [BffSearchSalesIncentiveType.KortingProcent]:
        SalesIncentiveType.KortingProcent,
    [BffSearchSalesIncentiveType.FolderPrijs]: SalesIncentiveType.FolderPrijs,
    [BffSearchSalesIncentiveType.OutletPrijs]: SalesIncentiveType.OutletPrijs,
    [BffSearchSalesIncentiveType.EveryDayLowPrice]:
        SalesIncentiveType.EveryDayLowPrice,
    [BffSearchSalesIncentiveType.GratisTransport]:
        SalesIncentiveType.GratisTransport,
    [BffSearchSalesIncentiveType.ExtraBonusPunten]:
        SalesIncentiveType.ExtraBonusPunten
};

const fromBffSearchToAlgoliaSearchMap: Record<
    BffSearchSalesIncentiveType,
    AlgoliaSearchSalesIncentiveType
> = {
    [BffSearchSalesIncentiveType.Cashback]:
        AlgoliaSearchSalesIncentiveType.Cashback,
    [BffSearchSalesIncentiveType.ActiePrijs]:
        AlgoliaSearchSalesIncentiveType.ActiePrijs,
    [BffSearchSalesIncentiveType.CombinatiePrijs]:
        AlgoliaSearchSalesIncentiveType.CombinatiePrijs,
    [BffSearchSalesIncentiveType.GratisArtikel]:
        AlgoliaSearchSalesIncentiveType.GratisArtikel,
    [BffSearchSalesIncentiveType.KortingProcent]:
        AlgoliaSearchSalesIncentiveType.KortingProcent,
    [BffSearchSalesIncentiveType.FolderPrijs]:
        AlgoliaSearchSalesIncentiveType.FolderPrijs,
    [BffSearchSalesIncentiveType.OutletPrijs]:
        AlgoliaSearchSalesIncentiveType.OutletPrijs,
    [BffSearchSalesIncentiveType.EveryDayLowPrice]:
        AlgoliaSearchSalesIncentiveType.EveryDayLowPrice,
    [BffSearchSalesIncentiveType.GratisTransport]:
        AlgoliaSearchSalesIncentiveType.GratisTransport,
    [BffSearchSalesIncentiveType.ExtraBonusPunten]:
        AlgoliaSearchSalesIncentiveType.ExtraBonusPunten
};

const fromBffToBffSearchMap: Record<
    SalesIncentiveType,
    BffSearchSalesIncentiveType
> = {
    [SalesIncentiveType.Cashback]: BffSearchSalesIncentiveType.Cashback,
    [SalesIncentiveType.ActiePrijs]: BffSearchSalesIncentiveType.ActiePrijs,
    [SalesIncentiveType.CombinatiePrijs]:
        BffSearchSalesIncentiveType.CombinatiePrijs,
    [SalesIncentiveType.GratisArtikel]:
        BffSearchSalesIncentiveType.GratisArtikel,
    [SalesIncentiveType.KortingProcent]:
        BffSearchSalesIncentiveType.KortingProcent,
    [SalesIncentiveType.FolderPrijs]: BffSearchSalesIncentiveType.FolderPrijs,
    [SalesIncentiveType.OutletPrijs]: BffSearchSalesIncentiveType.OutletPrijs,
    [SalesIncentiveType.EveryDayLowPrice]:
        BffSearchSalesIncentiveType.EveryDayLowPrice,
    [SalesIncentiveType.GratisTransport]:
        BffSearchSalesIncentiveType.GratisTransport,
    [SalesIncentiveType.ExtraBonusPunten]:
        BffSearchSalesIncentiveType.ExtraBonusPunten
};

const fromCloudToBffSearchMap: Record<
    CloudSalesIncentiveType,
    BffSearchSalesIncentiveType
> = {
    [CloudSalesIncentiveType.Cashback]: BffSearchSalesIncentiveType.Cashback,
    [CloudSalesIncentiveType.ActiePrijs]:
        BffSearchSalesIncentiveType.ActiePrijs,
    [CloudSalesIncentiveType.CombinatiePrijs]:
        BffSearchSalesIncentiveType.CombinatiePrijs,
    [CloudSalesIncentiveType.GratisArtikel]:
        BffSearchSalesIncentiveType.GratisArtikel,
    [CloudSalesIncentiveType.KortingProcent]:
        BffSearchSalesIncentiveType.KortingProcent,
    [CloudSalesIncentiveType.FolderPrijs]:
        BffSearchSalesIncentiveType.FolderPrijs,
    [CloudSalesIncentiveType.OutletPrijs]:
        BffSearchSalesIncentiveType.OutletPrijs,
    [CloudSalesIncentiveType.EveryDayLowPrice]:
        BffSearchSalesIncentiveType.EveryDayLowPrice,
    [CloudSalesIncentiveType.GratisTransport]:
        BffSearchSalesIncentiveType.GratisTransport,
    [CloudSalesIncentiveType.ExtraBonusPunten]:
        BffSearchSalesIncentiveType.ExtraBonusPunten
};

export const SalesIncentiveTypeMapper = {
    fromCloudToBff: (salesIncentive: CloudSalesIncentiveType) =>
        fromCloudToBffMap[salesIncentive],
    fromCloudToAlgoliaSearch: (salesIncentive: CloudSalesIncentiveType) =>
        fromCloudToAlgoliaSearchMap[salesIncentive],
    fromCloudToBffSearch: (salesIncentive: CloudSalesIncentiveType) =>
        fromCloudToBffSearchMap[salesIncentive],
    fromBffToCloud: (salesIncentive: SalesIncentiveType) =>
        fromBffToCloudMap[salesIncentive],
    fromBffToAlgoliaSearch: (salesIncentive: SalesIncentiveType) =>
        fromBffToAlgoliaSearchMap[salesIncentive],
    fromBffToBffSearch: (salesIncentive: SalesIncentiveType) =>
        fromBffToBffSearchMap[salesIncentive],
    fromAlgoliaSearchToBff: (salesIncentive: AlgoliaSearchSalesIncentiveType) =>
        fromAlgoliaSearchToBffMap[salesIncentive],
    fromAlgoliaSearchToBffSearch: (
        salesIncentive: AlgoliaSearchSalesIncentiveType
    ) => fromAlgoliaSearchToBffSearchMap[salesIncentive],
    fromBffSearchToBff: (salesIncentive: BffSearchSalesIncentiveType) =>
        fromBffSearchToBffMap[salesIncentive],
    fromBffSearchToAlgoliaSearch: (
        salesIncentive: BffSearchSalesIncentiveType
    ) => fromBffSearchToAlgoliaSearchMap[salesIncentive]
};
